// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"
import "./src/index.scss"
require("prism-themes/themes/prism-dracula.css")
